'use strict'

export default function formatDate(date,emptyValue) {
  return date!==undefined
    ? new Date(Date.parse(date)).toISOString().substring(0,10)
    : emptyValue
}



// WEBPACK FOOTER //
// ./views/log/formatDate.js